import { MailIcon } from 'lucide-react';

import { cn } from 'src/lib/utils';

type Props = {
  className?: string;
};

const AppRequestTaskIcon = ({ className }: Props) => {
  return <MailIcon className={cn('text-foreground', className)} />;
};

export default AppRequestTaskIcon;
